// eslint-disable-next-line no-restricted-globals
export const API_HOST = process.env.REACT_APP_API_HOST || `${window.location.protocol}//${window.location.host}/`;
